var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "customer" },
          [
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.isShowCustomerModal,
                  title: _vm.isInsert
                    ? _vm.$t("customer.insertCustomer")
                    : _vm.$t("customer.updateCustomer"),
                  width: "40%",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowCustomerModal = $event
                  },
                },
              },
              [
                _vm.isShowCustomerModal
                  ? _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "left",
                          "label-width": "12em",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("customer.company") } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  disabled: !_vm.isInsert,
                                  filterable: "",
                                },
                                on: { change: _vm.handleSelectCompany },
                                model: {
                                  value: _vm.selectedCompany,
                                  callback: function ($$v) {
                                    _vm.selectedCompany = $$v
                                  },
                                  expression: "selectedCompany",
                                },
                              },
                              _vm._l(
                                _vm.companies,
                                function (company, companyIndex) {
                                  return _c("el-option", {
                                    key: companyIndex,
                                    attrs: {
                                      label: company.CompName,
                                      value: company.RecId,
                                      disabled: _vm.registeredCompIds.includes(
                                        company.RecId
                                      ),
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        !_vm.isInsert
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("customer.companyId"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      type: "text",
                                      id: "companyId",
                                      name: "companyId",
                                    },
                                    model: {
                                      value: _vm.formData._id,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "_id", $$v)
                                      },
                                      expression: "formData._id",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("customer.companyKey"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      type: "text",
                                      id: "companyKey",
                                      name: "companyKey",
                                    },
                                    model: {
                                      value: _vm.formData.key,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "key", $$v)
                                      },
                                      expression: "formData.key",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("customer.companyCode") } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: !_vm.isInsert,
                                type: "text",
                                id: "companyCode",
                                name: "companyCode",
                              },
                              model: {
                                value: _vm.formData.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "code", $$v)
                                },
                                expression: "formData.code",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("customer.companyName") } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "text",
                                id: "companyName",
                                name: "companyName",
                              },
                              model: {
                                value: _vm.formData.company,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "company", $$v)
                                },
                                expression: "formData.company",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("customer.planidFormat")) +
                                    " "
                                ),
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "customer.planidFormatDesc"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "exclamation-circle" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("el-input", {
                              attrs: {
                                type: "text",
                                id: "planIdFormat",
                                name: "planIdFormat",
                              },
                              model: {
                                value: _vm.formData.data.planIdFormat,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.data,
                                    "planIdFormat",
                                    $$v
                                  )
                                },
                                expression: "formData.data.planIdFormat",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("customer.country") } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "text",
                                id: "country",
                                name: "country",
                              },
                              model: {
                                value: _vm.formData.data.country,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData.data, "country", $$v)
                                },
                                expression: "formData.data.country",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("customer.latlng") } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "text",
                                id: "latlng",
                                name: "latlng",
                              },
                              model: {
                                value: _vm.formData.data.latlng,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData.data, "latlng", $$v)
                                },
                                expression: "formData.data.latlng",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("customer.timezone") } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                model: {
                                  value: _vm.formData.data.timezone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData.data, "timezone", $$v)
                                  },
                                  expression: "formData.data.timezone",
                                },
                              },
                              _vm._l(_vm.timeZoneList, function (timezone) {
                                return _c("el-option", {
                                  key: timezone.value,
                                  attrs: {
                                    label: timezone.text,
                                    value: timezone.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("customer.permission") } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: { multiple: "" },
                                model: {
                                  value: _vm.formData.data.permission,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.data,
                                      "permission",
                                      $$v
                                    )
                                  },
                                  expression: "formData.data.permission",
                                },
                              },
                              _vm._l(_vm.permissionList, function (permission) {
                                return _c("el-option", {
                                  key: permission,
                                  attrs: {
                                    label: _vm.$t("customer." + permission),
                                    value: permission,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c("hr", { staticClass: "mt-5" }),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("customer.updateUserData") },
                          },
                          [
                            _c("el-switch", {
                              model: {
                                value: _vm.formData.data.updateUserData,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.data,
                                    "updateUserData",
                                    $$v
                                  )
                                },
                                expression: "formData.data.updateUserData",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("customer.checkReadyToShip"),
                            },
                          },
                          [
                            _c("el-switch", {
                              model: {
                                value: _vm.formData.data.checkReadyToShip,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.data,
                                    "checkReadyToShip",
                                    $$v
                                  )
                                },
                                expression: "formData.data.checkReadyToShip",
                              },
                            }),
                            _vm.formData.data.checkReadyToShip
                              ? [
                                  _c("el-checkbox", {
                                    staticClass: "ml-3",
                                    attrs: {
                                      label: _vm.$t(
                                        "customer.orderAssignmentReadyToShip"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.formData.data
                                          .orderAssignmentReadyToShip,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.data,
                                          "orderAssignmentReadyToShip",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.data.orderAssignmentReadyToShip",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("settings.google") } },
                          [
                            _c("el-switch", {
                              model: {
                                value: _vm.formData.default5,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "default5", $$v)
                                },
                                expression: "formData.default5",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("settings.zoneLogic") } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "settings.zoneLogicSelect"
                                  ),
                                },
                                model: {
                                  value: _vm.formData.default30,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "default30", $$v)
                                  },
                                  expression: "formData.default30",
                                },
                              },
                              _vm._l(_vm.zoneList, function (zoneValue) {
                                return _c("el-option", {
                                  key: zoneValue,
                                  attrs: {
                                    label: _vm.$t("settings." + zoneValue),
                                    value: zoneValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c("el-button", { on: { click: _vm.handleHideCustomer } }, [
                      _vm._v(" " + _vm._s(_vm.$t("general.cancel")) + " "),
                    ]),
                    _vm.isInsert
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled:
                                !_vm.formData.code || !_vm.formData.company,
                            },
                            on: { click: _vm.addCustomer },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("general.insert")) + " ")]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: _vm.helper.isEmptyString(
                                _vm.formData.company
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.updateCustomer(_vm.formData._id)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("general.update")) + " ")]
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", gutter: 8 } },
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "table-header" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-position": "left",
                            "label-width": "5em",
                            inline: true,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("customer.searchText") } },
                            [
                              _c("el-input", {
                                attrs: { name: "search", id: "search" },
                                model: {
                                  value: _vm.searchValue,
                                  callback: function ($$v) {
                                    _vm.searchValue = $$v
                                  },
                                  expression: "searchValue",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "float-right",
                                  attrs: { type: "success" },
                                  on: { click: _vm.handleShowCustomerInsert },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-none d-sm-block" },
                                    [_vm._v(_vm._s(_vm.$t("customer.insert")))]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "d-block d-sm-none" },
                                    [_vm._v("+")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          size: "mini",
                          border: "",
                          data: _vm.getCustomer(),
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            width: "40",
                            fixed: "",
                            type: "index",
                            index: _vm.indexMethod,
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("customer.company"),
                            "column-key": "company",
                            prop: "company",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            width: "220",
                            label: _vm.$t("customer.country"),
                            "column-key": "data",
                            prop: "data.country",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            width: "220",
                            label: _vm.$t("customer.permission"),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.helper
                                            .get(
                                              scope,
                                              "row.data.permission",
                                              []
                                            )
                                            .join(", ")
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2420170142
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            width: "60",
                            label: _vm.$t("customer.apiCount"),
                            "column-key": "data",
                            prop: "count1",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { width: "150" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mt-2 mb-2",
                                        attrs: {
                                          type: "info",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.handleShowCustomer(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "pen" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mt-2 mb-2",
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.handleDeleteCustomer(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "trash" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1313505244
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "pagination-container", attrs: { span: 24 } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        layout: "sizes, total, prev, pager, next",
                        "page-sizes": [10, 20, 30, 50, 100, 300],
                        "current-page": _vm.currentPage,
                        "page-size": _vm.pageSize,
                        total: _vm.totalData,
                      },
                      on: {
                        "size-change": _vm.onSizeChange,
                        "current-change": _vm.onPagination,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }